import { render, staticRenderFns } from "./Armeria.vue?vue&type=template&id=513034dc&scoped=true&"
import script from "./Armeria.vue?vue&type=script&lang=js&"
export * from "./Armeria.vue?vue&type=script&lang=js&"
import style0 from "./Armeria.vue?vue&type=style&index=0&id=513034dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513034dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
